﻿(function (d, ns) {
  ns.initRecentSearchesModule = function () {
    ns.loadRecentSearches();
  };

  ns.loadRecentSearches = function () {
    fetch('/api/user/get-recent-searches')
      .then(response => {
        if (!response.ok) {
          throw new Error(`Error ${response.status}: Failed to fetch recent searches.`);
        }

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("text/html")) {
          throw new Error("Wrong content type response.");
        }

        return response.json();
      })
      .then(data => {
        if (data.success) {
          ns.renderRecentSearches(data.recentSearches);
        } else {
          console.log("Failed to load recent searches:", data.message || "Unknown error.");
        }
      })
      .catch(error => {
        console.log("An error occurred while loading recent searches:", error);
      });
  };

  ns.renderRecentSearches = function (recentSearches) {
    // get the Mustache template from the page
    const template = d.getElementById('recent-search-template').innerHTML;
    const container = d.getElementById('recentSearchesContainer');
    const resultsWrapper = d.querySelector('.recent-searches-wrapper');

    if (!recentSearches || recentSearches.length === 0) {
      resultsWrapper.style.display = 'none';
      return;
    }


    // render the template with recent search data
    container.innerHTML = Mustache.render(template, { recentSearches });

    resultsWrapper.style.display = '';

    container.querySelectorAll('.recent-searches-results__search-btn').forEach(btn => {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        ns.handleSearchRedirect(this);
      });
    });

    container.querySelectorAll('.recent-searches-results__close-btn').forEach(btn => {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        ns.deleteRecentSearch(this.getAttribute('data-id'));
      });
    });

  };

  ns.handleSearchRedirect = function (btn) {
    const searchText = btn.getAttribute('data-search-text');
    let searchUrl = btn.getAttribute('data-search-url');

    if (searchUrl) {      
      window.location.href = searchUrl;
    } else {
      // if no searchUrl, retrieve the base search URL and append search text as a query parameter
      const searchPageUrl = document.querySelector('[data-search-page-url]').getAttribute('data-search-page-url');
      const fullSearchUrl = `${searchPageUrl}?searchtext=${encodeURIComponent(searchText)}`;
      window.location.href = fullSearchUrl;
    }
  };

  ns.deleteRecentSearch = function (searchId) {
    fetch(`/api/user/delete-recent-search?searchId=${searchId}`, { method: 'POST' })
      .then(response => {
        if (!response.ok) {
          throw new Error("Failed to delete recent search");
        }
        return response.json();
      })
      .then(data => {
        if (data.success) {
          ns.loadRecentSearches();
        } else {
          console.error("Deletion failed:", data.message);
        }
      })
      .catch(error => {
        console.error("An error occurred:", error);
      });
  };

  d.addEventListener('DOMContentLoaded', function () {
    ns.initRecentSearchesModule();
  });
})(document, Crafted.Utilities);